module.exports = __webpack_public_path__ + "img/qcode.3f4f1001.png";